import type { WorldCupForecastState, WorldCupMatchSource, WorldCupTeamId } from '@wc26-forecast/model/types';

export function resolveWorldCupMatchSourceTeamId(
  source: WorldCupMatchSource,
  state: WorldCupForecastState,
): WorldCupTeamId | null {
  if (source.type === 'GROUP_PLACE') {
    return state.prediction.groupPlacements[source.group]?.[source.place] ?? null;
  }
  if (source.type === 'BEST_THIRD') {
    return state.prediction.bestThirdTeams[source.slot] ?? null;
  }
  if (source.type === 'MATCH_WINNER') {
    return state.prediction.matchResults[source.matchId]?.winnerTeamId ?? null;
  }
  if (source.type === 'MATCH_LOSER') {
    return state.prediction.matchResults[source.matchId]?.loserTeamId ?? null;
  }
  return null;
}
